import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqid from 'uniqid';
import { Modal } from '@bwoty-web/ui-kit';
import { isCountry } from '../../../utils/geoTypeUtils';
import SectionParagraph from '../../../common/sectionParagraph';

import './tileContent.scss';

const WeatherContent = ({
  tile,
  isExpanded,
  close,
  weatherChart,
  itemType,
}) => {
  const classes = classNames('tile-popup', `tile-popup-${tile?.key}`);

  const weatherText = isCountry(itemType) ? tile?.content[0] : tile?.content[1];

  return (
    <Modal
      className={classes}
      isOpen={isExpanded}
      size="m"
      onClose={() => close(tile?.key)}
      heading={tile?.header}
    >
      <div className="tile-popup-content-container">
        {weatherText &&
          weatherText?.paragraphs?.map((paragraph) => {
            return (
              <SectionParagraph
                paragraph={paragraph}
                key={uniqid('resort-paragraph-')}
              />
            );
          })}
        {tile?.climateData && weatherChart}
      </div>
    </Modal>
  );
};

WeatherContent.propTypes = {
  tile: PropTypes.shape({
    header: PropTypes.string.isRequired,
    key: PropTypes.string,
    content: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.shape({}),
    ]),
    labels: PropTypes.shape({}),
    climateData: PropTypes.shape({}),
  }).isRequired,
  isExpanded: PropTypes.bool,
  close: PropTypes.func.isRequired,
  weatherChart: PropTypes.node,
  itemType: PropTypes.string.isRequired,
};

WeatherContent.defaultProps = {
  isExpanded: false,
  weatherChart: null,
};

export default WeatherContent;
